import { Injectable, NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MessagesService } from '../messages/messages.service';
import { ListasService } from '../listas/listas.service';
import { urlApi } from '../../../utils/apiConfig';


@Injectable()


export class DisparoService {

  constructor(private http: HttpClient, private messageService: MessagesService, private listaService: ListasService) {

   }

  public getDisparos(page: number): Observable<any>{
    return this.http.get(`${urlApi}/app/disparos/${page}`);
  }

  public stopDisparo(idDisparo: number): Observable<any>{
    return this.http.patch(`${urlApi}/app/disparos/stop`, {iddisparo: idDisparo});
  }

  public resendDisparo(idDisparo: number): Observable<any> {
    return this.http.patch(`${urlApi}/app/disparos/resend`, {iddisparo: idDisparo});
  }

  public getMessagesPreDefined(): Observable<any>{
    return this.messageService.getMessages();
  }

  public getCanaisNormal(): Observable<any>{
    return this.http.get(`${urlApi}/app/channels/normal`);
  }

  public getCanaisOficial(): Observable<any>{
    return this.http.get(`${urlApi}/app/channels/apioficial`);
  }

  public setDisparoNormalCsv(payload: FormData): Observable<any>{
    return this.http.post(`${urlApi}/app/flow`, payload,
      
    );
  }

  /**
   * Funcao para retornar a lista de listas de contatos
   */
  public getListas(): Observable<any>{
    return this.listaService.getListas();
  }

  /**
   * Funcao para realizar disparo por lista
   */
  public setDisparoNormalLista(objectData: FormData): Observable<any>{
    return this.http.post(`${urlApi}/app/flow/lista`, objectData);
  }

  /**
   * Funcao para realizar disparo usando csv na apioficial
   */
  public setDisparoNormalOficial(objectData: FormData): Observable<any>{
    return this.http.post(`${urlApi}/app/flow/apioficial`, objectData);
  }

  //Funcao para enviar disparo por lista na apioficial
  public setDisparoQueueOficial(objectData: any): Observable<any>{
    return this.http.post(`${urlApi}/app/flow/apioficial/list`, objectData);
  }
}


